// FIXME: redo the keys for the table.
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { NavLink } from 'react-router-dom';

import Button from 'components/form/Button.component';
import Space from 'components/generic/Space.component';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import { DownloadExcelButton } from './DownloadExcelButton';

import CN from './ReportTableV2.module.scss';

const ReportTableV2 = ({
  data,
  title,
  startDate,
  endDate,
  children,
  linkText,
  linkUrl,
  withBoldFooter, // last row of the table is a bold footer row
}) => {
  const { t } = useTranslation();

  const renderLeftHeaderTbl = () => {
    if (!data.leftHeader) {
      return null;
    }
    let defaultStyle = '';
    if (data.leftHeader.styles.length > 0) {
      if (data.leftHeader.styles.length === 1) {
        [defaultStyle] = data.leftHeader.styles;
      }
    }

    return (
      <>
        {children}
        <table className="table-reports first">
          <tbody>
            {data.leftHeader.inputFields.map((field, index) => {
              const isLastRow = index === data.rows.length; // because left header has one more row than content rows
              return (
                <tr key={createNodeKey({ index, tag: field })} className={withBoldFooter && isLastRow ? CN.boldFooterRow : ''}>
                  <td className={data.leftHeader && data.leftHeader.styles[index] ? data.leftHeader.styles[index] : defaultStyle}>
                    {/* This tooltip  is visible only in Bookings by status table */}
                    <span className="bubble">
                      <span className="tooltip">
                        <div />
                      </span>
                    </span>
                    <div className="column-name">{field}</div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };

  const renderTopHeaderTbl = () => {
    if (!data.topHeader) {
      return null;
    }
    let defaultStyle = '';
    if (data.topHeader.styles.length > 0) {
      if (data.topHeader.styles.length === 1) {
        [defaultStyle] = data.topHeader.styles;
      }
    }

    return (
      <tr className="thead">
        {data.topHeader.inputFields.map((field, i) => (
          <td style={{ width: '121px', height: '57px' }} key={`${field}+${i}`} className={data.topHeader && data.topHeader.styles[i] ? data.topHeader.styles[i] : defaultStyle}>
            <span className="bubble">
              <span className="tooltip">
                <div />
              </span>
            </span>
            <span className="column-title"> {field}</span>
          </td>
        ))}
        <th className="last-empty" style={{ width: 'auto' }} />
      </tr>
    );
  };

  const createCSV = () => {
    if (!data) return [];

    const topHeaders = data?.topHeader?.inputFields;
    const leftHeaders = data?.leftHeader?.inputFields;
    const content = data?.rows;

    if (!Array.isArray(leftHeaders) || leftHeaders.length === 0) {
      return [];
    }

    if (!Array.isArray(content) || content.length === 0) {
      return [];
    }

    const fallbackHeader = isFullArray(topHeaders) ? topHeaders : Array.isArray(content[0]?.inputFields) ? content[0].inputFields : [];

    const headers = [leftHeaders[0], ...fallbackHeader];

    const rowsData = isFullArray(topHeaders) ? content : content.slice(1);
    const rows = rowsData.map((row, index) => {
      const label = leftHeaders[index + 1] || '';

      const inputFields = Array.isArray(row?.inputFields) ? row.inputFields : [];

      return [label, ...inputFields];
    });

    const csv = rows.map((row) =>
      headers.reduce((obj, key, index) => {
        obj[key] = row[index] !== undefined ? row[index] : '';
        return obj;
      }, {}),
    );

    return csv;
  };

  const leftHeaderTbl = renderLeftHeaderTbl();
  const topHeaderTbl = renderTopHeaderTbl();
  const hasTableData = fromAnyToBool(data.rows.length);
  const hasLinkButton = fromAnyToBool(linkText && linkUrl);

  return (
    <>
      <div className="t-bgr cfix">
        <div className="t-wrap">
          <div className={CN.buttonsContainer}>
            {hasLinkButton && (
              <NavLink to={linkUrl}>
                <Button variant="primaryForce" width="small" onClick={alwaysNoop}>
                  <span className={CN.buttonFont}>{linkText}</span>
                </Button>
              </NavLink>
            )}

            <DownloadExcelButton getCsvData={createCSV} fileName={title} disabled={!hasTableData} />
          </div>
          {title && <h2>{title}</h2>}
          <div>
            <table style={{ width: '100%' }} id={title}>
              <tbody>
                <tr>
                  <td colSpan="3">
                    <div className="date-in-tbl-for-export">
                      {t('businessReports.monthly.dateRangePart1')}
                      <Space>
                        <strong>{startDate}</strong>
                      </Space>
                      {t('businessReports.monthly.dateRangePart2')}
                      <Space>
                        <strong>{endDate}</strong>
                      </Space>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '168px' }} className="v2-first-column">
                    {leftHeaderTbl}
                  </td>
                  <td>
                    <table className="table-reports second">
                      <tbody className=" ">
                        {topHeaderTbl}
                        {data.rows.map((row, ind) => {
                          const isLastRow = ind === data.rows.length - 1;
                          let defaultStyle = '';
                          if (row.styles.length > 0) {
                            if (row.styles.length === 1) {
                              [defaultStyle] = row.styles;
                            }
                          }
                          return (
                            <tr key={`${row.inputFields.toString()}_${ind}`} className={withBoldFooter && isLastRow ? CN.boldFooterRow : ''}>
                              {row.inputFields.map((field, i) => (
                                <td style={{ width: '121px' }} key={`${field}+${i}`} className={row.styles[i] ? `${row.styles[i]} t-cell` : `${defaultStyle} t-cell`}>
                                  <div>{field}</div>
                                </td>
                              ))}
                              <td className="last-empty-cell" style={{ width: 'auto' }} />
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportTableV2;
